import { render, staticRenderFns } from "./PasswordRecoveryForm.vue?vue&type=template&id=6f293cd5&scoped=true"
import script from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoveryForm.vue?vue&type=style&index=0&id=6f293cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f293cd5",
  null
  
)

export default component.exports